"use client";

import clsx from "clsx";
import type { CSSProperties, ReactNode } from "react";
import { useEffect, useRef, useState } from "react";

/** 本文を collapsedLines で省略し、 超過時のみ「さらに表示」を出す。 開いたら戻らない (Figma)。 */
type DxTextGroupProps = {
  children: ReactNode;
  collapsedLines?: number;
  expandLabel?: string;
  className?: string;
};

export function DxTextGroup({
  children,
  collapsedLines = 5,
  expandLabel = "さらに表示",
  className,
}: DxTextGroupProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [canExpand, setCanExpand] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el === null) return;
    // clamp が効いていれば scrollHeight > clientHeight (= 「さらに表示」を出すべき)。
    setCanExpand(el.scrollHeight > el.clientHeight + 1);
  }, [children, collapsedLines]);

  const clampStyle: CSSProperties = expanded
    ? {}
    : {
        display: "-webkit-box",
        WebkitLineClamp: collapsedLines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
      };

  return (
    <div className={clsx("flex flex-col gap-[8px]", className)}>
      <div
        ref={ref}
        className="dx-body-1 text-dx-text-default whitespace-pre-line"
        style={clampStyle}
      >
        {children}
      </div>
      {!expanded && canExpand && (
        <button
          type="button"
          onClick={() => setExpanded(true)}
          // 「もっと見る」の表示展開だけで、行動の分析対象にならない
          data-analytics-ignore
          className="dx-body-2-bold text-dx-text-default cursor-pointer self-start underline hover:opacity-80"
        >
          {expandLabel}
        </button>
      )}
    </div>
  );
}
